import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DateLocalePipe } from '@modeso/aumico-lib-core-fe';
import { ReportType } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy } from '@ngneat/until-destroy';
import { GeneralInformationMode } from '../../../enums/general-information-form-mode.enum';
import { IGeneralInformationV2Output } from '../../../interfaces/general-information-form-output.interface';
import { GeneralInformationBaseComponent } from '../base/general-information-base.component';

@UntilDestroy()
@Component({
    selector: 'aumico-general-information-saved',
    templateUrl: '../general-information-v2.component.html',
    styleUrls: ['../general-information-v2.component.scss'],
})
export class GeneralInformationSavedComponent extends GeneralInformationBaseComponent implements OnInit, OnChanges {
    @Input() savedData: IGeneralInformationV2Output | undefined;

    get mode(): GeneralInformationMode {
        return GeneralInformationMode.SAVED;
    }

    // Getters specific to SAVED mode
    get showAutofillFromPreviousForBalanceToggle(): boolean {
        return this.form?.get('autofillFromPreviousForBalance')?.value === true;
    }

    get showAutofillFromPreviousForIncomeToggle(): boolean {
        return this.form?.get('autofillFromPreviousForIncome')?.value === true;
    }

    get showBalanceSheetReportSelection(): boolean {
        return this.form?.get('autofillFromPreviousForBalance')?.value === true;
    }

    get showIncomeStatementReportSelection(): boolean {
        return this.form?.get('autofillFromPreviousForIncome')?.value === true;
    }

    constructor(formBuilder: FormBuilder, dateLocalePipe: DateLocalePipe) {
        super(formBuilder, dateLocalePipe);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.initializeSavedMode();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['savedData'] && this.savedData) {
            this.initializeSavedMode();
        }
        if (
            changes['previousAnnualReportOptions']
        ) {
            this.prepareSelectReportOptions();

        }
    }

    private initializeSavedMode(): void {
        if (!this.savedData && !this.setupData) return;
        // Set all relevant fields to disabled in saved mode
        this.disableCompany = true;
        this.disableAccountingBasis = true;
        this.disableArTemplate = true;
        this.disableLanguage = true;
        this.disablePreviousSettings = true;

        this.storedPreviousYearDates = {
            balancePreviousYearDate: this.savedData?.balancePreviousYearDate || null,
            incomePreviousYearFromDate: this.savedData?.incomePreviousYearFromDate || null,
            incomePreviousYearToDate: this.savedData?.incomePreviousYearToDate || null,
        };

        if (
            this.setupData == null ||
            this.setupData.reportType === ReportType.ANNUAL ||
            this.setupData.reportType == null
        ) {
            this.disableReportType = true;
        }

        // Set the dropdowns data if available from saved data
        this.setDropdownsFromSavedData();

        // Patch the form with saved data
        this.form.patchValue(this.savedData, { emitEvent: false });

        // Update form control states after setting disabled flags
        this.updateFormControlStates();

        // Emit form data since we have pre-filled everything
        this.emitFormData();
    }

    private setDropdownsFromSavedData(): void {

        if (this.savedData.autofillReportForBalance) {
            this.disablePreviousSettings = true;
            this.balanceSheetReportOptions = [this.savedData.autofillReportForBalance];
        } else {
            this.disablePreviousSettings = false;
        }

        if (this.savedData.autofillReportForIncome) {
            this.disablePreviousSettings = true;
            this.incomeStatementReportOptions = [this.savedData.autofillReportForIncome];
        } else {
            this.disablePreviousSettings = false;
        }
    }
}
